export const printStatus = (issuer = null) => {
  if (!issuer) {
    return 'Väntar på godk.'
  }

  return issuer
}